import { routesUrl } from '@/constants';
export const navigation = [
  { 
    name: 'Home', 
    url: routesUrl.dashboard,
    icon: 'house-blank'
  },
  { 
    name: 'Attributi', 
    url: routesUrl.attributes,
    icon: 'tags'
  },
  { 
    name: 'Categorie', 
    url: routesUrl.categories,
    icon: 'layer-group'
  },
  { 
    name: 'Prodotti', 
    url: routesUrl.products,
    icon: 'shirt'
  },
  { 
    name: 'Giacenze', 
    url: routesUrl.stocks,
    icon: 'warehouse'
  },
  { 
    name: 'Ordini', 
    url: routesUrl.orders,
    icon: 'boxes-packing'
  },
  { 
    name: 'Impostazioni', 
    url: routesUrl.settings,
    icon: 'gear'
  },
  { 
    name: 'Guida', 
    url: routesUrl.guide,
    icon: 'book-blank'
  },
];